export const get = url => fetchWithTimeout(url, 'GET')

const ApplicationJsonValue = 'application/json'
const Headers = {
  ACCEPT: 'Accept',
  CONTENT_TYPE: 'Content-Type',
}

const fetchWithTimeout = (url, method, timeout = 30000) => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject('Timeout'), timeout)

    fetch(url, {
      method,
      headers: {
        [Headers.ACCEPT]: ApplicationJsonValue,
        [Headers.CONTENT_TYPE]: ApplicationJsonValue,
      },
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
    })
      .then(response => {
        clearTimeout(timer)
        if (response.status >= 200 && response.status < 300) {
          return resolve(isJson(response) ? response.json() : {})
        }
        if (isJson(response)) {
          return reject(handleError(response.json()))
        }
        return reject(handleError())
      })
      .catch(reject)
  })
}

const isJson = response =>
  response.headers.get(Headers.CONTENT_TYPE) === ApplicationJsonValue

const handleError = ({ message } = {}) => message || 'Generic Error'
